import { FunctionFactory } from 'survey-core';
import { Gender } from "./gender";
import { Physiology } from './physiology';
import { getGenderKey } from '../features/utils';

enum AreaBody {
  Belly = 'Belly',
  LoveHandles = 'Love Handles',
  Chest = 'Chest',
  LowerBack = 'Lower Back',
  Legs = 'Legs',
  Arms = 'Arms',
  Hips = 'Hips',
  Equally = 'Equally',
}

const areaBodyQuestion = {
  name: 'areaBody',
  title: 'What area(s) are the most difficult to lose fat from?',
  description: 'Select up to 3. This helps us see where most people face challenges.',
  descriptionLocation: 'underTitle',
  choices: [
    {
      value: AreaBody.Belly,
      text: 'Belly',
    },
    {
      value: AreaBody.LoveHandles,
      text: 'Love Handles',
    },
    {
      value: AreaBody.Chest,
      text: 'Chest',
    },
    {
      value: AreaBody.LowerBack,
      text: 'Lower Back',
    },
    {
      value: AreaBody.Legs,
      text: 'Legs',
    },
    {
      value: AreaBody.Arms,
      text: 'Arms',
    },
    {
      value: AreaBody.Hips,
      text: 'Hips',
    },
    {
      value: AreaBody.Equally,
      text: 'They are all equally difficult',
    },
  ],
  isRequired: true,
  type: 'checkbox',
  maxSelectedChoices: 3,
};

const areaBodyGenderExpression = {
  name: 'areaBodyGenderText',
  expression: 'renderAreaBodyGenderText({gender}, {physiology})',
};

function renderAreaBodyGenderText(params: any[]): string {
  if (params === undefined || params === null) return '';

  const gender = params[0] as Gender;
  const physiology = params[1] as Physiology;
  const genderKey = getGenderKey(gender, physiology);

  switch (genderKey) {
    case Gender.Male:
      return `man`;
    case Gender.Female:
      return `woman`;
  }
}

FunctionFactory.Instance.register('renderAreaBodyGenderText', renderAreaBodyGenderText);

export { AreaBody, areaBodyQuestion, areaBodyGenderExpression };
